import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { formatCurrency, getCurrencySymbol } from '../../../utils/currency';

const AccountCard = ({ account, onEdit, onDelete, onViewDetails }) => {
  const navigate = useNavigate();

  const accountCurrencySymbol = getCurrencySymbol();

  const getAccountTypeIcon = (type) => {
    const iconMap = {
      'Chequing': 'Landmark',
      'Savings': 'PiggyBank',
      'Credit Card': 'CreditCard',
      'Line of Credit': 'TrendingUp',
      'Cash': 'Wallet',
      'Investment': 'TrendingUp',
      'Loan': 'FileText'
    };
    return iconMap?.[type] || 'Wallet';
  };

  const isLiability = account?.group === 'Liabilities';
  const displayBalance = isLiability 
    ? `${formatCurrency(account?.balance)} owed`
    : formatCurrency(account?.balance);

  const balanceColor = isLiability 
    ? 'text-error' 
    : account?.balance >= 0 
      ? 'text-success' :'text-error';

  return (
    <div className="bg-card rounded-lg p-20 md:p-24 shadow-elevation-2 hover:shadow-elevation-3 transition-smooth border border-border">
      <div className="flex items-start justify-between mb-16">
        <div className="flex items-center flex-1 min-w-0">
          <div className="flex items-center justify-center w-12 h-12 bg-primary/10 rounded-lg flex-shrink-0">
            <Icon 
              name={getAccountTypeIcon(account?.type)} 
              size={24} 
              color="var(--color-primary)"
              strokeWidth={2}
            />
          </div>
          <div className="ml-12 flex-1 min-w-0">
            <h3 className="text-base md:text-lg font-heading font-semibold text-card-foreground truncate">
              {account?.name}
            </h3>
            <p className="text-sm text-muted-foreground mt-2">
              {account?.type}
            </p>
          </div>
        </div>
      </div>
      <div className="mb-20">
        <p className="text-xs md:text-sm text-muted-foreground mb-4">
          Current Balance
        </p>
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-muted-foreground mb-4">Balance</p>
            <p className="text-2xl font-heading font-bold text-foreground">
              {formatCurrency(account?.balance)}
            </p>
          </div>
        </div>
      </div>
      <div className="flex gap-8 md:gap-12">
        <Button
          variant="default"
          size="sm"
          fullWidth
          iconName="Eye"
          iconPosition="left"
          iconSize={16}
          onClick={() => navigate(`/accounts/${account?.id}`)}
        >
          View Details
        </Button>
        <Button
          variant="outline"
          size="sm"
          fullWidth
          iconName="Edit"
          iconPosition="left"
          iconSize={16}
          onClick={() => onEdit?.(account)}
        >
          Edit
        </Button>
        <Button
          variant="outline"
          size="sm"
          iconName="Trash2"
          iconSize={16}
          onClick={() => onDelete?.(account)}
          className="border-error/30 text-error hover:bg-error/10 hover:border-error/50"
          title="Delete account"
        />
      </div>
    </div>
  );
};

export default AccountCard;